export const LEASE_TYPE = {
	// single lease for entire place
	EntirePlace: 'single',
	// single lease per room (multiple leases for entire place)
	SingleRoom: 'multi',
};
